import { useMemo } from 'react';
import type { Modifier } from 'react-popper';

export const useSameWidthModifier = () => {

  return useMemo(() => {
    const modifier: Modifier<'sameWidth'> = {
      name: 'sameWidth',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: ({ state }) => {
        state.styles.popper.width = `${state.rects.reference.width}px`;
      },
      effect: ({ state }) => {
        const refWidth = (state.elements.reference as HTMLDivElement).offsetWidth;
        state.elements.popper.style.width = `${refWidth}px`;
      },
    };
    return modifier;
  }, []);
};